import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { OperationStatus } from "libraries/service/resources/model/search/IBooking";
import {
    faCheckCircle,
    faExclamationTriangle,
    faQuestion,
    faTimesCircle,
    IconDefinition
} from "@fortawesome/free-solid-svg-icons";

@Component({
    selector: 'booking-operation-result-icon',
    template: `
        <fa-icon *ngIf="result" [icon]="icon" class="{{cssClass}}"></fa-icon>
        <span *ngIf="!result" class="noInformation">∅</span>
    `,
    styles: [`
        .success {
            color: #3c763d;
        }

        .warning {
            color: #8a6d3b;
        }

        .error {
            color: #a94442;
        }

        .noInformation {
            color: rgb(110, 110, 110);
        }
    `]
})
export class BookingOperationResultIconComponent implements OnChanges{

    @Input()
    public result: OperationStatus;

    public cssClass: string;

    public icon: IconDefinition;

    public ngOnChanges(changes: SimpleChanges): void {
        switch (changes.result.currentValue) {
            case OperationStatus.success:
                this.icon = faCheckCircle;
                this.cssClass = "success";
                break;
            case OperationStatus.warning:
                this.cssClass =  "warning";
                this.icon = faExclamationTriangle;
                break;
            case OperationStatus.error:
                this.cssClass =  "error";
                this.icon = faTimesCircle;
                break;
            default:
                this.icon = faQuestion;
                this.cssClass =  "";
                break;
        }
    }
}
